import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Draw } from 'ol/interaction'
import useMap from 'hooks/use-map'
import { noop } from 'es-toolkit/compat'

export default function DrawLineInteraction(props) {
  const { onDrawLine = noop } = props

  const map = useMap()

  const [interaction, setInteraction] = useState()

  useEffect(() => {
    if (!map) return
    // using Draw interaction with type 'LineString' to let user draw a line
    const drawInteraction = new Draw({ type: 'LineString' })
    map.addInteraction(drawInteraction)
    setInteraction(drawInteraction)
    return () => {
      map.removeInteraction(drawInteraction)
      setInteraction(undefined)
    }
  }, [map])

  useEffect(() => {
    if (!interaction) return

    function onDrawEnd(e) {
      // Return the drawn geometry (ol/geom/LineString) and perhaps the pixel for a popup if needed
      onDrawLine(e.feature.getGeometry())
    }

    interaction.on('drawend', onDrawEnd)

    return () => {
      interaction.un('drawend', onDrawEnd)
    }
  }, [interaction, onDrawLine])

  return null
}

DrawLineInteraction.propTypes = { onDrawLine: PropTypes.func }
